import Cookies from 'universal-cookie';
import { SHOPPING_LIST_COOKIE_KEY } from 'common/constants';

export const getLayers = (cookieString = '') => {
  const cookies = new Cookies(cookieString);

  const comparisonCookies = cookies.get('comparison');
  const comparison = comparisonCookies?.split(',') ?? [];

  const shoplistCookies = cookies.get(SHOPPING_LIST_COOKIE_KEY);
  const shoppingList =
    shoplistCookies?.split(';').map((item: string) => item.slice(0, item.indexOf(':'))) ?? [];

  const layersObj = {
    comparison,
    shoppingList,
  };

  return layersObj;
};
